module.exports = __webpack_public_path__ + "static/media/monument.a7bdacaf.svg";